import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'

import ApplicationView from './ApplicationView'

//
// get the rootElement
//
const Application = appOptions => {
  const rootElement = appOptions.rootElement || document.getElementById('root')

  ReactDOM.render(
    <StrictMode>
      <ApplicationView appOptions={appOptions} />
    </StrictMode>,
    rootElement
  )
}

export default Application
